import React, { PureComponent } from "react";
import styled from "styled-components";

const Wrapper = styled.div`
  background-color: rgba(214, 185, 161, 0.2);
  padding: 8px 0;
  min-height: 57px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
`;

const MultiWrapper = styled.div`
  background-color: rgba(214, 185, 161, 0.2);
  padding: 0 16px;
  min-height: 57px;
  height: 86px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;

  @media screen and (max-width: 479px) {
    height: 120px;
  }

  & > .multi-wrapper {
    display: flex;
    flex-direction: row;
    padding: 10px 0 14px 0;

    @media screen and (max-width: 479px) {
      flex-wrap: wrap;
      justify-content: center;
    }
  }

  & > .submit-btn {
    width: 100%;
    height: 22px;
    border-radius: 4px;
    background-color: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;

    & > p {
      font-size: 15px;
      color: #b08963;
      letter-spacing: 1.5px;
    }
  }
`;

const ButtonWrapper = styled.div`
  background-color: ${props => (props.isActived ? "#CCA37B" : "transparent")};
  border-radius: 15px;
  margin: 5px;
  padding: 3px 8px;
  min-width: 200px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  border-width: 1px;
  border-style: solid;
  border-color: #cca37b;
  ${props => props.css};

  & > p {
    font-size: 14px;
    color: ${props => (props.isActived ? "#fff" : "rgba(14,14,14,0.50)")};
    letter-spacing: 1.4px;
  }
`;

class ChattyAnswerInput extends PureComponent {
  state = {
    selectedOptions: []
  };

  _selectOption = option => {
    const { selectedOptions } = this.state;

    const targetIndex = selectedOptions.findIndex(
      item => item.value === option.value
    );

    if (!~targetIndex) {
      this.setState({ selectedOptions: [...selectedOptions, option] });
    } else {
      this.setState({
        selectedOptions: [
          ...selectedOptions.slice(0, targetIndex),
          ...selectedOptions.slice(targetIndex + 1)
        ]
      });
    }
  };

  render() {
    const { question, onAnswer, disabled } = this.props;
    const extra = question.extra || {};

    if (disabled) {
      return null;
    }

    if (question.type === "select") {
      if (extra.type === "single-select") {
        return (
          <Wrapper>
            {question.choices.map((choice, idx) => (
              <ButtonWrapper
                key={idx}
                isFirst={idx === 0}
                isLast={idx === question.choices.length - 1}
                disabled={disabled}
                onClick={() => onAnswer(idx)}
                isActived
              >
                <p>{choice.label}</p>
              </ButtonWrapper>
            ))}
          </Wrapper>
        );
      }
    }

    if (question.type === "text") {
      if (extra.type === "multi-select") {
        const { selectedOptions } = this.state;

        return (
          <MultiWrapper>
            <div className="multi-wrapper">
              {question.choices.map((choice, idx) => (
                <ButtonWrapper
                  css="margin: 1px 3px"
                  key={idx}
                  isFirst={idx === 0}
                  isLast={idx === question.choices.length - 1}
                  onClick={() => this._selectOption(choice)}
                  disabled={disabled}
                  isActived={
                    !!selectedOptions.find(item => item.value === choice.value)
                  }
                >
                  <p>{choice.label}</p>
                </ButtonWrapper>
              ))}
            </div>
            <div
              className="submit-btn"
              onClick={() => {
                if (selectedOptions.length > 0) {
                  const answer = selectedOptions.map(op => op.value).join("、");
                  onAnswer(answer);
                }
              }}
            >
              <p>送出</p>
            </div>
          </MultiWrapper>
        );
      }
    }

    return <Wrapper />;
  }
}

export default ChattyAnswerInput;
